function getOrderOnlineLink(title) {
  const linkMap = {
    "meat-the-bun-nw-edmonton-5539": "https://orders.iorders.online/meat-the-bun-nw-edmonton-5539",
    "meat-the-bun-edmonton-5538": "https://orders.iorders.online/meat-the-bun-edmonton-5538",
    "meat-the-bun-bar-bistro-whyte-ave-edmonton-5702": "https://orders.iorders.online/meat-the-bun-bar-bistro-whyte-ave-edmonton-5702/"
  };

  return linkMap[title] || "N/A";
}

// ... rest of the code remains unchanged
const storeDetails = {
  status: "success",
  data: {
    restaurants: [
      //1. Meat The Bun - West Edmonton
      {
        profile: {
          id: 5539,
          restaurant_name: "Meat The Bun West Edmonton",
          title: "meat-the-bun-nw-edmonton-5539",
          address: "9919 170 St NW, Edmonton, AB T5P 4S2, Canada",
          phone: "+1 (587) 400-3823",
          available_days: [
            {
              id: 1001,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1002,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1003,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1004,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1005,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1006,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1007,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.5379214",
          lng: "-113.6141534",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //2. Meat The Bun - South Edmonton (open until 2:45 AM Fri & Sat nights)
      {
        profile: {
          id: 5538,
          restaurant_name: "Meat The Bun South Edmonton",
          title: "meat-the-bun-edmonton-5538",
          address: "9080 25 Ave SW #118, Edmonton, AB T6X 2H4, Canada",
          phone: "+1 (587) 754-5863",
          available_days: [
            {
              id: 1011,
              day: "SUNDAY",
              opening_time: "00:00:00",
              closing_time: "02:45:00",
              order_mode: 1,
            },
            {
              id: 1012,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1013,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1014,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1015,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1016,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1017,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "23:59:59",
              order_mode: 1,
            },
            {
              id: 1018,
              day: "SATURDAY",
              opening_time: "00:00:00",
              closing_time: "02:45:00",
              order_mode: 1,
            },
            {
              id: 1019,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "23:59:59",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.4108115",
          lng: "-113.4819261",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //3. Meat The Bun Bar & Bistro - Whyte Ave (open until 3:30 AM Fri & Sat nights)
      {
        profile: {
          id: 5702,
          restaurant_name: "Meat The Bun Bar & Bistro - Whyte Ave",
          title: "meat-the-bun-bar-bistro-whyte-ave-edmonton-5702",
          address: "10542 82 Ave NW, Edmonton, AB T6E 2A4, Canada",
          phone: "+1 (587) 855-1700",
          available_days: [
            {
              id: 1021,
              day: "SUNDAY",
              opening_time: "00:00:00",
              closing_time: "03:30:00",
              order_mode: 1,
            },
            {
              id: 1022,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "22:00:00",
              order_mode: 1,
            },
            {
              id: 1023,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "22:00:00",
              order_mode: 1,
            },
            {
              id: 1024,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "22:00:00",
              order_mode: 1,
            },
            {
              id: 1025,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "22:00:00",
              order_mode: 1,
            },
            {
              id: 1026,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "22:00:00",
              order_mode: 1,
            },
            {
              id: 1027,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "23:59:59",
              order_mode: 1,
            },
            {
              id: 1028,
              day: "SATURDAY",
              opening_time: "00:00:00",
              closing_time: "03:30:00",
              order_mode: 1,
            },
            {
              id: 1029,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "23:59:59",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.5183501",
          lng: "-113.5021021",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      
      //5. Meat The Bun - Sherwood Park (online ordering coming soon)
      {
        profile: {
          id: 5802,
          restaurant_name: "Meat The Bun Sherwood Park",
          title: "",
          address: "270 Baseline Rd #122, Sherwood Park, AB T8H 1R4, Canada",
          phone: "+1 (825) 419-8255",
          available_days: [
            {
              id: 1051,
              day: "SUNDAY",
              opening_time: "11:00:00",
              closing_time: "23:59:59",
              order_mode: 1,
            },
            {
              id: 1052,
              day: "MONDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1053,
              day: "TUESDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1054,
              day: "WEDNESDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1055,
              day: "THURSDAY",
              opening_time: "11:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1056,
              day: "FRIDAY",
              opening_time: "11:00:00",
              closing_time: "23:59:59",
              order_mode: 1,
            },
            {
              id: 1057,
              day: "SATURDAY",
              opening_time: "11:00:00",
              closing_time: "23:59:59",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.5420125",
          lng: "-113.3099651",
          order_online_link: "N/A",
        },
      },
    ],
  },
  message: "successful response",
};

export default storeDetails;
